import OrderDetail from '@/components/OrdersModule/OrderDetail/OrderDetail'
import { useRouterCanGoBackParamSubscriber } from '@/features/navigation/hooks/can-go-back'
import { useClearNonexistentSelectedOrder } from '@/features/orders/hooks/useClearNonexistentSelectedOrder'
import { useScreenLayout } from '@/hooks/screen'
import { Redirect, useLocalSearchParams } from 'expo-router'
import { FC } from 'react'

const CompactOrderDetailPage: FC = () => {
    const { uuid } = useLocalSearchParams<{ uuid: string }>()

    const isNonexistent = useClearNonexistentSelectedOrder(uuid)

    const layout = useScreenLayout()

    useRouterCanGoBackParamSubscriber()

    if (isNonexistent) {
        return <Redirect href="/archive" />
    }

    if (layout === 'extended') return <Redirect href="/archive/(tabs)" />

    return <OrderDetail uuid={uuid} />
}

export default CompactOrderDetailPage
